"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Pagination = _interopRequireDefault(require("../Pagination"));

var _tKeys = require("./tKeys");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Footer = /*#__PURE__*/function (_Component) {
  _inherits(Footer, _Component);

  var _super = _createSuper(Footer);

  function Footer() {
    var _this;

    _classCallCheck(this, Footer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getPagination", function () {
      var _this$props$params = _this.props.params,
          pagination = _this$props$params.pagination,
          t = _this$props$params.t,
          tKeys = _this$props$params.tKeys,
          classNames = _this$props$params.classNames;
      if (!pagination) return null;
      if (pagination.component) return pagination.component;

      if (pagination.data && pagination.data.total) {
        if (classNames && classNames.includes('elastic') && pagination.data.total <= pagination.data.limit) {
          return null;
        }

        var props = _objectSpread(_objectSpread({}, pagination.data), {}, {
          onChange: pagination.onChange,
          translatedText: {
            of: t((0, _tKeys.getTKey)(tKeys, 'paginationOf'))
          }
        });

        return /*#__PURE__*/_react["default"].createElement(_Pagination["default"], props);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getControls", function () {
      var footer = _this.props.params.footer;

      if (!footer || !footer.submit && !footer.cancel) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "grid-footer-controls"
      }, _this.getCancel(), _this.getSubmit());
    });

    _defineProperty(_assertThisInitialized(_this), "getCancel", function () {
      var _this$props$params2 = _this.props.params,
          t = _this$props$params2.t,
          tKeys = _this$props$params2.tKeys,
          footer = _this$props$params2.footer,
          _this$props$params2$c = _this$props$params2.cancelL10n,
          cancelL10n = _this$props$params2$c === void 0 ? 'btnFooterCancel' : _this$props$params2$c;
      if (!footer.cancel) return null;
      return /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "button cancel",
        onClick: footer.cancel
      }, /*#__PURE__*/_react["default"].createElement("i", {
        className: "icon-close"
      }), t((0, _tKeys.getTKey)(tKeys, cancelL10n)));
    });

    _defineProperty(_assertThisInitialized(_this), "getSubmit", function () {
      var _this$props = _this.props,
          selected = _this$props.selected,
          _this$props$params3 = _this$props.params,
          t = _this$props$params3.t,
          tKeys = _this$props$params3.tKeys,
          footer = _this$props$params3.footer;
      if (!footer.submit) return null;

      if (selected) {
        return /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "button",
          onClick: footer.submit(selected)
        }, /*#__PURE__*/_react["default"].createElement("i", {
          className: "icon-check"
        }), t((0, _tKeys.getTKey)(tKeys, 'btnFooterSelect')));
      }

      return /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "button disabled"
      }, /*#__PURE__*/_react["default"].createElement("i", {
        className: "icon-check"
      }), t((0, _tKeys.getTKey)(tKeys, 'btnFooterSelect')));
    });

    return _this;
  }

  _createClass(Footer, [{
    key: "render",
    value: function render() {
      var pagination = this.getPagination();
      var controls = this.getControls();

      if (!pagination && !controls) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "grid-footer"
      }, pagination, controls);
    }
  }]);

  return Footer;
}(_react.Component);

exports["default"] = Footer;
Footer.propTypes = {
  params: _propTypes["default"].object,
  selected: _propTypes["default"].object
};